const colors = {
  white: "#ffffff",
  black: "#1B1313",
  green: "#547272",
  main: "#ec7538",
  sub: "#B2A5FE",
  lightgray: "#e7e7e7",
  darkgray: "#dcdde1",
  gray: "#8A8A8B",
  red: "#FF0000",
};

const font = {
  title: `
      font-size: 18px;
      font-weight: 700;
    `,
  largeTitle: `
      font-size: 24px;
      font-weight: 700;
    `,
  bold: `
      font-weight: 700;
    `,
  large: `
      font-size:  22px;
      font-weight: 600;
      line-height: 26px;
    `,
  medium: `
      font-size: 16px;
      font-weight: 700;
    `,
  mediumSmall: `
      font-size: 14px;
      font-weight: 400;
    `,
  small: `
      font-size: 12px;
      font-weight: 400;
    `,
};

const theme = {
  colors,
  font,
};

export default theme;
